import { DatePicker, MobileDateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { TextInput } from 'flowbite-react';
import { MutableRefObject, useContext } from 'react';
import { ThemeContext } from 'src/context/ThemeProvider';
import { SlotTime } from 'types';

interface Props {
	selectedTimeSlot: SlotTime;
	setSelectedTimeSlot: (value: SlotTime) => void;
}

const AIInterviewScheduleStep = ({ selectedTimeSlot, setSelectedTimeSlot }: Props) => {
	const ThemeContextState = useContext(ThemeContext);
	return (
		<div className="flex flex-col">
			<div className={'mb-0'}>
				<p className={`${'greyish_text_dark_theme dark:text-[#C7C9D9] font-[500] text-[15px] mb-2'}`}>
					Select a date & time
				</p>

				<MobileDateTimePicker
					defaultValue={dayjs(selectedTimeSlot.time)}
					minDateTime={dayjs()}
					value={dayjs(selectedTimeSlot?.time)}
					format="DD MMM, YYYY, hh:mm A"
					onChange={date => {
						const dateValue = date as { $d?: Date };
						setSelectedTimeSlot({
							time: dayjs(dateValue?.$d).toDate(),
							count: 1,
						});
					}}
					sx={{
						'&': {
							width: '100%',
						},
						'& .MuiInputBase-input': {
							padding: '10px',
							borderRadius: '8px',
							backgroundColor: ThemeContextState.themeMode === 'light' ? '#FFF' : 'rgb(55, 65, 81)',
							border: ThemeContextState.themeMode === 'light' ? '1px solid #EBEBF0':'1px solid rgb(75, 85, 99)',
							fontSize: '14px',
						},
						'& .MuiInputBase-root': {
							outline: 'none',
							padding: '0px',
							'&:hover': {
								outline: 'none',
							},
						},
						'& fieldset': {
							display: 'none',
						},
					}}
				/>
			</div>
		</div>
	);
};

export default AIInterviewScheduleStep;
